import PropTypes from "prop-types";

import Modal from "react-bootstrap/Modal";

import Button from "react-bootstrap/Button";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

const CustomModal = ({
  isShown,
  setIsShown,
  classNameOfModal,
  positiveAction,
  negativeAction,
  titleOfModal,
  content,
  negativeButton,
  positiveButton,
  isBackdrop,
  isCentered,
  //typeOfPositiveActionButton,
  formId,
  isPositiveButtonDisabled,
  onClick,
}) => {
  const [subscription, setSubscription] = useState(false);
  let data = sessionStorage.getItem("singleTopic.SUBSCRIPTION");

  useEffect(() => {
    if (data) {
      setSubscription(data);
    }
  }, [data]);

  // eslint-disable-next-line react-redux/useSelector-prefer-selectors
  const subscriptionFrequency = useSelector(
    (state) => state.subscriptionReducer.subscriptionFrequency
  );
  // eslint-disable-next-line react-redux/useSelector-prefer-selectors
  const subscriptionTypes = useSelector(
    (state) => state.subscriptionReducer.subscriptionTypes
  );

  const disabledCheck =
    subscriptionFrequency === null ||
    subscriptionFrequency === "Please select" ||
    subscriptionTypes === null ||
    subscriptionTypes === "Please select";

  return (
    <Modal
      centered={isCentered}
      show={isShown}
      backdrop={isBackdrop}
      className={classNameOfModal}
    >
      <Modal.Header
        closeButton
        onHide={() => {
          setIsShown(false);
          negativeAction();
          sessionStorage.removeItem("separateNewsAsk");
        }}
      >
        {titleOfModal}
      </Modal.Header>
      {/* {console.log(titleOfModal)} */}
      <Modal.Body>{content}</Modal.Body>
      {titleOfModal !== "Ask a Question" && titleOfModal !== "Save Results" && (
        <Modal.Footer>
          {/* {console.log(subscription === "TRUE")} */}
          <div
            className="common-wrapper-footer-btn"
            style={{
              justifyContent: subscription !== "TRUE" && "right",
            }}
          >
            {titleOfModal === "Edit Subscription" && subscription === "TRUE" && (
              <Button
                onClick={onClick}
                className="modal-negative-button apply-bg-white-color fs-14"
                style={{ color: "#ff6c4b", border: "1px solid #ff6c4b" }}
              >
                Cancel Subscription
              </Button>
            )}
            {titleOfModal !== "Save Results" && titleOfModal !== "Edit a news" && (
              <div className="inner-wrapper-footer-btn">
                <Button
                  onClick={negativeAction}
                  className="modal-negative-button apply-bg-white-color fs-14"
                >
                  {negativeButton}
                </Button>
                <Button
                  form={formId}
                  //type={typeOfPositiveActionButton}
                  disabled={
                    titleOfModal !== "Edit Subscription"
                      ? isPositiveButtonDisabled
                      : disabledCheck
                  }
                  onClick={positiveAction}
                  className={
                    "modal-positive-button apply-bg-approx-analog-color fs-14"
                  }
                >
                  {titleOfModal === "Edit Subscription"
                    ? "Save Edits"
                    : positiveButton}
                </Button>
              </div>
            )}
            {titleOfModal === "Edit a news" && formId !== "add-news-form" && (
              <div className="inner-wrapper-footer-btn">
                <Button
                  onClick={negativeAction}
                  className="modal-negative-button apply-bg-white-color fs-14"
                >
                  {negativeButton}
                </Button>
                <Button
                  form={formId}
                  disabled={isPositiveButtonDisabled}
                  onClick={positiveAction}
                  className={
                    "modal-positive-button apply-bg-approx-analog-color fs-14"
                  }
                >
                  {positiveButton}
                </Button>
              </div>
            )}
          </div>
        </Modal.Footer>
      )}
    </Modal>
  );
};

CustomModal.propTypes = {
  isShown: PropTypes.bool.isRequired,
  setIsShown: PropTypes.func.isRequired,
  classNameOfModal: PropTypes.string,
  positiveAction: PropTypes.func,
  negativeAction: PropTypes.func,
  titleOfModal: PropTypes.oneOfType([PropTypes.string, PropTypes.shape({})]),
  content: PropTypes.node,
  negativeButton: PropTypes.string,
  positiveButton: PropTypes.string,
  isBackdrop: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  isCentered: PropTypes.bool.isRequired,
  //typeOfPositiveActionButton: PropTypes.string,
  formId: PropTypes.string,
  isPositiveButtonDisabled: PropTypes.bool,
  onClick: PropTypes.func,
  // disabled: PropTypes.bool,
};

CustomModal.defaultProps = {
  isShown: false,
  setIsShown: () => {},
  classNameOfModal: "",
  positiveAction: () => {},
  negativeAction: () => {},
  onClick: () => {},
  titleOfModal: "",
  content: <> </>,
  negativeButton: "",
  positiveButton: "",
  isBackdrop: false,
  isCentered: false,
  // typeOfPositiveActionButton: undefined,
  formId: undefined,
  isPositiveButtonDisabled: false,
  disabled: true,
};

export default CustomModal;
// import PropTypes from "prop-types";

// import Modal from "react-bootstrap/Modal";

// import Button from "react-bootstrap/Button";
// import { useEffect, useState } from "react";
// import { useSelector } from "react-redux";

// const CustomModal = ({
//   isShown,
//   setIsShown,
//   classNameOfModal,
//   positiveAction,
//   negativeAction,
//   titleOfModal,
//   content,
//   negativeButton,
//   positiveButton,
//   isBackdrop,
//   isCentered,
//   //typeOfPositiveActionButton,
//   formId,
//   isPositiveButtonDisabled,
//   onClick,
// }) => {
//   const [subscription, setSubscription] = useState(false);
//   let data = sessionStorage.getItem("singleTopic.SUBSCRIPTION");

//   useEffect(() => {
//     if (data) {
//       setSubscription(data);
//     }
//   }, [data]);

//   // eslint-disable-next-line react-redux/useSelector-prefer-selectors
//   const subscriptionFrequency = useSelector(
//     (state) => state.subscriptionReducer.subscriptionFrequency
//   );
//   // eslint-disable-next-line react-redux/useSelector-prefer-selectors
//   const subscriptionTypes = useSelector(
//     (state) => state.subscriptionReducer.subscriptionTypes
//   );

//   const disabledCheck =
//     subscriptionFrequency === null ||
//     subscriptionFrequency === "Please select" ||
//     subscriptionTypes === null ||
//     subscriptionTypes === "Please select";

//   return (
//     <Modal
//       centered={isCentered}
//       show={isShown}
//       backdrop={isBackdrop}
//       className={classNameOfModal}
//     >
//       <Modal.Header
//         closeButton
//         onHide={() => {
//           setIsShown(false);
//           negativeAction();
//           sessionStorage.removeItem("separateNewsAsk");
//         }}
//       >
//         {titleOfModal}
//       </Modal.Header>
//       {console.log("titleOfModal", titleOfModal)}
//       <Modal.Body>{content}</Modal.Body>
//       {titleOfModal !== "Ask a Question" && titleOfModal !== "Save Results" && (
//         <Modal.Footer>
//           {console.log("subscription === TRUE", subscription === "TRUE")}
//           <div
//             className="common-wrapper-footer-btn"
//             style={{
//               justifyContent: subscription !== "TRUE" && "right",
//             }}
//           >
//             {titleOfModal === "Edit Subscription" && subscription === "TRUE" ? (
//               <Button
//                 onClick={onClick}
//                 className="modal-negative-button apply-bg-white-color fs-14"
//                 style={{ color: "#ff6c4b", border: "1px solid #ff6c4b" }}
//               >
//                 Cancel Subscription
//               </Button>
//             ) : (
//               ""
//             )}
//             {titleOfModal !== "Save Results" && (
//               <div className="inner-wrapper-footer-btn">
//                 <Button
//                   onClick={negativeAction}
//                   className="modal-negative-button apply-bg-white-color fs-14"
//                 >
//                   {negativeButton}
//                 </Button>
//                 <Button
//                   form={formId}
//                   //type={typeOfPositiveActionButton}
//                   disabled={
//                     titleOfModal !== "Edit Subscription"
//                       ? isPositiveButtonDisabled
//                       : disabledCheck
//                   }
//                   onClick={positiveAction}
//                   className={
//                     "modal-positive-button apply-bg-approx-analog-color fs-14"
//                   }
//                 >
//                   {titleOfModal === "Edit Subscription"
//                     ? "Save Edits"
//                     : positiveButton}
//                 </Button>
//               </div>
//             )}
//           </div>
//         </Modal.Footer>
//       )}
//     </Modal>
//   );
// };

// CustomModal.propTypes = {
//   isShown: PropTypes.bool.isRequired,
//   setIsShown: PropTypes.func.isRequired,
//   classNameOfModal: PropTypes.string,
//   positiveAction: PropTypes.func,
//   negativeAction: PropTypes.func,
//   titleOfModal: PropTypes.oneOfType([PropTypes.string, PropTypes.shape({})]),
//   content: PropTypes.node,
//   negativeButton: PropTypes.string,
//   positiveButton: PropTypes.string,
//   isBackdrop: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
//   isCentered: PropTypes.bool.isRequired,
//   //typeOfPositiveActionButton: PropTypes.string,
//   formId: PropTypes.string,
//   isPositiveButtonDisabled: PropTypes.bool,
//   onClick: PropTypes.func,
// };

// CustomModal.defaultProps = {
//   isShown: false,
//   setIsShown: () => {},
//   classNameOfModal: "",
//   positiveAction: () => {},
//   negativeAction: () => {},
//   onClick: () => {},
//   titleOfModal: "",
//   content: <> </>,
//   negativeButton: "",
//   positiveButton: "",
//   isBackdrop: false,
//   isCentered: false,
//   // typeOfPositiveActionButton: undefined,
//   formId: undefined,
//   isPositiveButtonDisabled: false,
// };

// export default CustomModal;
